import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxuryforceurbaniaonrentinpune() {



  const cardData =
  {
    keyword: 'Luxury Force Urbania On Rent in Pune',
    heading: 'Amruta Travels: Luxury Force Urbania On Rent in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. offers Luxury Force Urbania on Rent in Pune, perfect for travelers seeking comfort, elegance, and superior performance. Our premium Urbania vans are ideal for corporate transfers, airport pickups, weddings, family tours, and celebrity travel, providing an unmatched combination of style and convenience. Each vehicle is equipped with luxurious push-back seats, ambient lighting, advanced air conditioning, and spacious interiors for a first-class journey experience. Driven by professional and courteous chauffeurs, our service ensures safety, punctuality, and complete privacy. Whether you’re traveling within Pune or to outstation destinations like Lonavala, Mahabaleshwar, or Shirdi, Amruta Travels’ Luxury Force Urbania Rental in Pune guarantees a smooth, elegant, and memorable ride every time.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Luxury Force Urbania On Rent in Pune",
      "description": "Experience premium travel with Luxury Force Urbania On Rent in Pune. These luxury vans are designed for comfort and style, equipped with air conditioning, spacious seating, and modern amenities. Ideal for corporate travel, weddings, and special occasions, these vans ensure a smooth and sophisticated journey across Pune and beyond."
    },
    {
      "name": "Force Urbania Hire Pune",
      "description": "Force Urbania Hire Pune offers versatile van rental services with options for both AC and Non-AC vehicles. Perfect for group travel, corporate outings, and family trips, these vans combine affordability with reliability, ensuring hassle-free transportation within Pune."
    },
    {
      "name": "Luxury Urbania Rental Pune",
      "description": "Luxury Urbania Rental Pune provides premium van rentals featuring elegant interiors and advanced comfort features. These luxury Urbanias are perfect for clients seeking a blend of style and convenience for city rides, outstation trips, or corporate events."
    },
    {
      "name": "Force Urbania AC Van Pune",
      "description": "Force Urbania AC Van Pune specializes in air-conditioned van rentals, ensuring passengers travel in a cool and comfortable environment. Suitable for all types of journeys, these AC vans offer an enhanced travel experience with spacious seating and reliable service."
    },
    {
      "name": "Force Urbania Non AC Pune",
      "description": "Force Urbania Non AC Pune offers cost-effective van rentals without air conditioning, ideal for short trips and budget-conscious travelers. Despite being non-AC, these vans maintain high standards of cleanliness and comfort."
    },
    {
      "name": "Premium Force Urbania Pune",
      "description": "Premium Force Urbania Pune delivers top-tier van rental services with luxury finishes and personalized service. Designed for VIP clients and special events, these vans guarantee a first-class travel experience with safety and style."
    },
    {
      "name": "Urbania Hire in Baner",
      "description": "Urbania Hire in Baner offers convenient van rental solutions tailored to the Baner area. With both AC and Non-AC options, these vans cater to corporate clients, families, and tourists needing comfortable transport in and around Baner."
    },
    {
      "name": "Urbania Hire in Hinjewadi",
      "description": "Urbania Hire in Hinjewadi focuses on providing efficient and comfortable van rentals for IT professionals, corporate groups, and local travelers. These vans ensure punctual and reliable service for daily commutes and special occasions."
    },
    {
      "name": "Urbania Hire in Hadapsar",
      "description": "Urbania Hire in Hadapsar provides a fleet of well-maintained vans for rent, suitable for business travel, family outings, and group tours. Clients can choose from AC and Non-AC options depending on their preferences and budget."
    },
    {
      "name": "Luxury Urbania for Corporate Pune",
      "description": "Luxury Urbania for Corporate Pune caters to business clients needing premium transport solutions. These vans offer comfort, privacy, and amenities suited for executive travel, client visits, and corporate events."
    },
    {
      "name": "Luxury Urbania for Wedding Pune",
      "description": "Luxury Urbania for Wedding Pune adds elegance to wedding transportation. These vans provide a stylish and comfortable ride for the bride, groom, and guests, ensuring a memorable and smooth journey on the special day."
    },
    {
      "name": "Luxury Urbania for Outstation Pune",
      "description": "Luxury Urbania for Outstation Pune offers long-distance van rentals equipped with luxury amenities for comfortable travel beyond Pune. Ideal for family trips, corporate tours, and pilgrimages, these vans combine convenience with style for outstation journeys."
    },
    {
      "name": "Force Urbania Booking Pune",
      "description": "Force Urbania Booking Pune provides an easy and quick way to reserve vans online or via phone. Customers can choose from a variety of Urbania models, customize their rental period, and get seamless booking confirmation with excellent customer support."
    },
    {
      "name": "Affordable Force Urbania Pune",
      "description": "Affordable Force Urbania Pune focuses on delivering budget-friendly van rental options without compromising quality. This service is ideal for daily commutes, school trips, and group outings looking for economical and reliable transport."
    },
    {
      "name": "Force Urbania Hire near Me Pune",
      "description": "Force Urbania Hire near Me Pune helps users find the closest available vans for rent in their vicinity, ensuring quick access and convenience for last-minute travel needs."
    },
    {
      "name": "Urbania Tour Van Pune",
      "description": "Urbania Tour Van Pune specializes in van rentals for sightseeing and tourist trips. Equipped with comfortable seating and large windows, these vans provide a pleasant travel experience for group tours across Pune and nearby destinations."
    },
    {
      "name": "Force Urbania Coach Pune",
      "description": "Force Urbania Coach Pune offers larger capacity vans for group travel with enhanced comfort features. Suitable for corporate outings, school trips, and extended tours, these coaches deliver reliable and stylish transport solutions."
    },
    {
      "name": "Luxury Urbania Pune to Mumbai",
      "description": "Luxury Urbania Pune to Mumbai service provides premium van rentals for intercity travel between Pune and Mumbai. These vans ensure a comfortable, air-conditioned journey with experienced drivers, perfect for business trips, leisure travel, and group tours."
    }
  ],
  "tableData": [
    ["Luxury Force Urbania On Rent in Pune", "Force Urbania Hire Pune"],
    ["Luxury Urbania Rental Pune", "Force Urbania AC Van Pune"],
    ["Force Urbania Non AC Pune", "Premium Force Urbania Pune"],
    ["Urbania Hire in Baner", "Urbania Hire in Hinjewadi"],
    ["Urbania Hire in Hadapsar", "Luxury Urbania for Corporate Pune"],
    ["Luxury Urbania for Wedding Pune", "Luxury Urbania for Outstation Pune"],
    ["Force Urbania Booking Pune", "Affordable Force Urbania Pune"],
    ["Force Urbania Hire near Me Pune", "Urbania Tour Van Pune"],
    ["Force Urbania Coach Pune", "Luxury Urbania Pune to Mumbai"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Luxury Force Urbania On Rent in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers premium Luxury Force Urbania rentals in Pune, ideal for stylish and comfortable group travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Equipped Interiors",
    "WhyChoosedescription": "Our Luxury Force Urbania vans come with plush seating, ample space, and modern amenities to ensure a superior travel experience."
  },
  {
    "WhyChooseheading": "Regular Maintenance and Sanitization",
    "WhyChoosedescription": "We maintain and sanitize every vehicle thoroughly to guarantee safety, cleanliness, and comfort."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Benefit from clear pricing with no hidden charges, providing great value for your luxury travel needs."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose hourly, daily, or customized rental options tailored to your schedule and preferences."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous drivers ensure punctual, safe, and smooth journeys every time."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, inquiries, and travel arrangements."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your Luxury Force Urbania conveniently online or via phone, with prompt and reliable service across Pune."
  }
]





















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer luxury Force Urbania on rent in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides luxury Force Urbania vehicles on rent in Pune, perfect for comfortable and stylish group travel.',
  },
  {
    question: 'How can I rent a luxury Force Urbania in Pune with Amruta Travels?',
    answer: 'You can easily book a luxury Force Urbania through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What amenities are available in the luxury Force Urbania vehicles in Pune?',
    answer: 'Our luxury Force Urbania vehicles come with plush seating, air conditioning, entertainment options, and essential safety features for a premium experience.',
  },
  {
    question: 'Are the drivers trained and experienced for luxury Force Urbania rentals in Pune?',
    answer: 'Absolutely. Our drivers are professional, courteous, and experienced in driving luxury Force Urbania vehicles safely and comfortably.',
  },
  {
    question: 'Can luxury Force Urbania vehicles be hired for weddings, corporate events, and tours in Pune?',
    answer: 'Yes, these vehicles are ideal for weddings, corporate outings, airport transfers, and sightseeing tours in Pune.',
  },
  {
    question: 'Is the luxury Force Urbania hire service available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for luxury Force Urbania hire services to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for luxury Force Urbania hires?',
    answer: 'All vehicles are thoroughly sanitized before every trip, and drivers adhere to strict hygiene and safety protocols.',
  },
  {
    question: 'What are the payment options for luxury Force Urbania hire in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the luxury Force Urbania hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Karan Desai',
    feedback: 'The luxury Force Urbania from Amruta Travels Pune was very comfortable and stylish. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Joshi',
    feedback: 'Great experience with Amruta Travels for luxury Force Urbania rental. Highly recommended for premium group travel in Pune.',
    rating: 5,
  },
];







































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Luxury Force Urbania On Rent in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/22.jpg",
  "description": "Book Luxury Force Urbania On Rent in Pune with Amruta Travels Pvt. Ltd. offering premium AC and Non-AC Urbania vans for corporate trips, weddings, and outstation journeys. Enjoy a comfortable and luxurious travel experience in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.93",
    "ratingCount": "14720"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/luxury-force-urbania-on-rent-in-pune"
  }
};





  return (
    <div>
<Helmet>
  <title>Luxury Force Urbania On Rent in Pune | Premium AC Van Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Luxury Force Urbania On Rent in Pune with Amruta Travels Pvt. Ltd. offering premium AC and Non-AC Urbania vans for corporate travel, weddings, and outstation trips. Experience ultimate comfort and style in Pune."
  />
  <meta
    name="keywords"
    content="Luxury Force Urbania On Rent in Pune, Force Urbania Hire Pune, Luxury Urbania Rental Pune, Force Urbania AC Van Pune, Force Urbania Non AC Pune, Premium Force Urbania Pune, Urbania Hire in Baner, Urbania Hire in Hinjewadi, Urbania Hire in Hadapsar, Luxury Urbania for Corporate Pune, Luxury Urbania for Wedding Pune, Luxury Urbania for Outstation Pune, Force Urbania Booking Pune, Affordable Force Urbania Pune, Force Urbania Hire near Me Pune, Urbania Tour Van Pune, Force Urbania Coach Pune, Luxury Urbania Pune to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxuryforceurbaniaonrentinpune;